import * as React from "react";
import { computed, action } from "mobx"
import { observer, inject } from "mobx-react";
import { DocumentPrivilegeMembershipEdit } from "./DocumentPrivilegesEdit.Membership";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import * as DocumentManagement from "../DocumentManagement";
import { SelectCheckbox } from "./SelectCheckbox";

interface IDocumentPrivilegeInfoProps {
	groupId: string;
	document: DocumentManagement.DocumentDetails;
	item: DocumentManagement.PrivilegesForGroup;
	collectionId: string;
	documentStore?: DocumentStoreImpl;
}


@inject('documentStore')
@observer
export class DocumentPrivilegeInfoEdit extends React.Component<IDocumentPrivilegeInfoProps, {}> {

	@computed get isSelected(): boolean {
		return this.props.documentStore.selectedPrivileges.some(p => p.groupId === this.props.item.groupId);
	}
	@action handleClickItem = (e: React.MouseEvent<any>) => {
		if (this.props.documentStore.privilegeSelectionMode) {
			if (!this.props.documentStore.selectedPrivileges.remove(this.props.item)) {
				this.props.documentStore.selectedPrivileges.push(this.props.item);
			}
			e.preventDefault();
		}
	}

	render() {
		return <tr data-test-name='privilegeGroup' data-test-id={this.props.item.groupName}>
			<td className="check-cell" data-test-name='privilegeSelect'>
				<SelectCheckbox onClick={this.handleClickItem.bind(this)} checked={this.isSelected} disabled={false} />
			</td>
			<td>{this.props.item.groupName}</td>
			{this.props.item.privilegeMemberships.map(privilege => {
				return <DocumentPrivilegeMembershipEdit collectionId={this.props.collectionId} key={this.props.groupId + privilege.name} document={this.props.document} groupId={this.props.groupId} item={privilege} />;
			})}
		</tr>
	}
}